import script from "./OrderAdjustment.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderAdjustment.vue?vue&type=script&setup=true&lang=ts"

import "./OrderAdjustment.vue?vue&type=style&index=0&id=fc28582e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc28582e"]])

export default __exports__